"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAILED = exports.PROCESSING = exports.AVAILABLE = exports.NEW = void 0;
exports.NEW = "NEW";
exports.AVAILABLE = "AVAILABLE";
exports.PROCESSING = "PROCESSING";
exports.FAILED = "FAILED";
